<template>
  <header class="sticky-header">
    <header-top-vue />
    <div class="calc-continer">
      <div class="mntly-view-calc">
        <router-link :to="'/year/' + getSelectedYear" class="back-to-year">
          <object
            class="svg-back-arrow"
            :data="backSvg"
            type="image/svg+xml"
          ></object>
          {{ getSelectedYear }}
        </router-link>
      </div>
      <div class="day-view-table-wrapper custom-month">
        <table class="day-view-table layout-fixed">
          <thead>
            <tr>
              <th>S</th>
              <th>M</th>
              <th>T</th>
              <th>W</th>
              <th>T</th>
              <th>F</th>
              <th>S</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="float-right header-icon-contain monthly-view-contain">
        <split-icon-vue :click="goToDaily" />
        <searc-icon-vue />
        <add-icon-vue />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SearcIconVue from "../common/SearchIcon.vue";
import AddIconVue from "../common/AddIcon.vue";
import SplitIconVue from "../common/SplitIcon.vue";
import HeaderTopVue from "../../common/HeaderTop.vue";

export default {
  components: {
    SearcIconVue,
    AddIconVue,
    SplitIconVue,
    HeaderTopVue
  },
  methods: {
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setWeek: "setWeek",
      openShowSplitScreenMonthly: "openShowSplitScreenMonthly"
    }),
    goToDaily() {
      this.openShowSplitScreenMonthly();
      const today = new Date();
      this.setDayOfMonth(today.getDate());
      this.setWeek(today.getDate());
      this.setMonth(today.getMonth());
      this.$router.push("/daily");
    }
  },
  computed: {
    ...mapGetters({
      getSelectedYear: "getSelectedYear"
    }),
    backSvg() {
      return require("../../../assets/svg/back.svg");
    }
  }
};
</script>

<style scoped>
.back-to-year {
  color: #d26d13;
  position: relative;
  top: -8px;
}

.mntly-view-calc,
.header-icon-contain {
  /*-- margin-top: 52px !important;--*/
}
</style>
